import React from "react";
import "./Kavling.scss";
import data from "./data.json";
import Card from "../../Component/Card Kavling/cardkavling";
import Kavlingimages from "../../Media/Kavling/Kavling";

const imageMap = {
  Kavlingimages,
  // Add other image arrays here if you have more sets
};

const produk = () => {
  return (
    <div id="kavling" className="kavling">
      <h1>Kavling</h1>
      <h2>Harga Start 11 Juta/Meter</h2>
      <div className="cardhome-containerf">
        {data.cards.map((card, index) => {
          // Determine the logo dynamically
          // Determine the logo dynamically
          return (
            <Card
              key={index}
              carousel={imageMap[card.imagesKey]}
              title={card.title}
              price={card.price}
              details={card.details}
              whatsappLink={card.whatsappLink} // Pass the WhatsApp link
            />
          );
        })}
      </div>
    </div>
  );
};

export default produk;
